import script from "./NakaInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./NakaInfo.vue?vue&type=script&setup=true&lang=js"

import "./NakaInfo.vue?vue&type=style&index=0&id=7636fb4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7636fb4d"]])

export default __exports__